import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { SzamlazoService } from '../szamlazo.service';

/*  BEÁLLÍTÁSOK – a kibocsátó (a cég) számlán megjelenő adatai (üresen a Könyvelés ügyféladata), a
 *  NAV-beküldés (a technikai felhasználó a Könyvelésé), a számlatömbök és – a könyvelőirodának –
 *  az ÜGYFÉL-HOZZÁFÉRÉS: ki dolgozhat a cég nevében a Számlázóban. */
@Component({
  selector: 'app-szamlazo-beallitasok',
  templateUrl: './beallitasok.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../szamlazo-shared.scss', './beallitasok.component.scss'],
})
export class BeallitasokComponent implements OnInit, OnDestroy {
  b: any = null;
  tombSzerk: any = null;
  hozzaferes: any[] | null = null;
  ujFelhasznalo = '';
  private sub?: Subscription;
  constructor(public sz: SzamlazoService, private toast: ToastController, private alert: AlertController) {}
  get u() { return this.sz.aktiv.ugyfelId; }
  get ir() { return this.sz.ir; }

  async ngOnInit() { await this.sz.init(); this.sub = this.sz.aktiv$.subscribe(() => this.frissit()); }
  ngOnDestroy() { this.sub?.unsubscribe(); }
  async frissit() {
    if (!this.u) { this.b = null; return; }
    try { this.b = await this.sz.get(`/beallitas/${this.u}`); } catch (e: any) { this.b = null; this.hiba(e?.error?.error || 'Nem sikerült betölteni.'); }
    //  A hozzáférés-kezelés a könyvelőirodáé – az ügyfél (403) nem látja.
    try { this.hozzaferes = await this.sz.get(`/hozzaferes/${this.u}`); } catch { this.hozzaferes = null; }
  }
  /** A külső pénztárgép típusai és a kiválasztott beállítása (alapértékekkel, ha még nincs). */
  get pgTipusok() { return Object.entries(this.b?.pg_tipusok || {}).map(([kod, nev]) => ({ kod, nev })); }
  get pgB(): any {
    if (!this.b) return null;
    if (!this.b.pg_beallitas) this.b.pg_beallitas = { ar_elotag: '23', azonosito_hossz: 6, cikk: {}, osszesites: 'afa', soros: false };
    this.b.pg_beallitas.cikk = this.b.pg_beallitas.cikk || {};
    return this.b.pg_beallitas;
  }
  async ment() {
    try { await this.sz.put(`/beallitas/${this.u}`, this.b); this.ok('Beállítások mentve.'); await this.frissit(); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }
  tipusNev(t: string) { return ({ szamla: 'Számla', dijbekero: 'Díjbekérő', storno: 'Sztornó', nyugta: 'Nyugta', nyugta_storno: 'Érvénytelenítő (nyugta)' } as any)[t] || t; }
  tombUj() { this.tombSzerk = { id: null, nev: '', elotag: '', tipus: 'szamla', folytonos: false, alapertelmezett: false, aktiv: true }; }
  tombNyit(t: any) { this.tombSzerk = { ...t, folytonos: !!Number(t.folytonos), alapertelmezett: !!Number(t.alapertelmezett), aktiv: !!Number(t.aktiv) }; }
  async tombMent() {
    try { await this.sz.post(`/tomb/${this.u}`, this.tombSzerk); this.tombSzerk = null; await this.frissit(); this.ok('Tömb mentve.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
  }
  async hozzaferesAd() {
    try {
      await this.sz.post(`/hozzaferes/${this.u}`, { felhasznalo: this.ujFelhasznalo });
      this.ujFelhasznalo = ''; this.ok('Hozzáférés megadva – a felhasználó a következő belépéskor látja a céget a Számlázóban.'); await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
  }
  async hozzaferesTorol(h: any) {
    const a = await this.alert.create({ header: 'Hozzáférés visszavonása', message: `${h.felhasznalo} többé nem dolgozhat a cég nevében a Számlázóban. Folytatod?`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Visszavonás', role: 'destructive', handler: async () => {
        try { await this.sz.del(`/hozzaferes/${this.u}/${h.id}`); await this.frissit(); this.ok('Visszavonva.'); }
        catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
      } }] });
    await a.present();
  }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 3000, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 4000, color: 'danger' })).present(); }
}
